import Navbar from "component/Common/Navbar";
import Sidebar from "component/Common/Sidebar";
import React, { useState } from "react";
import "./styles.scss";

export const MainLayout = (props) => {
  const [toggle, setToggle] = useState(false);

  const [isCollapse, setIsCollapse] = useState(false);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleCollapse = (data) => {
    setIsCollapse(data);
  };

  return (
    <div className="authLayout">
      <Navbar handleToggle={handleToggle} />
      <div className="row w-100">

        <Sidebar colClass={"col-2"} handleCollapse={handleCollapse} />


        <div
          className={`flex-fill mainLayout pl-0 ${!isCollapse ? "col-10" : "col-11"
            }`}
          style={isCollapse ? { width: "94%" } : {}}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};
